import { useEffect } from "react";
import CertView from "../certs";
import { openAttestationGetData } from "@cti-workspace/helpers";
import { Box } from "@cti-workspace/ui";
import WarningBanner from "../components/WarningBanner";

const processGetData = (rawDocument) => {
	try {
		let val = openAttestationGetData(rawDocument);
		if (val) {
			return val;
		} else {
			return rawDocument;
		}
	} catch (error) {
		return rawDocument;
	}
};

const FrameView = ({
	componentRef,
	rawDocument,
	certState,
	setIsDraft,
	additionalDataMain,
	creExpiredText,
	locale,
	showBadge,
	getBadgeUrl,
	setPrintPageSize = () => {},
	setCertBgImg = () => {},
	setFabricPageNames = () => {},
	activePageName = "",
	fabricCertiFullPageRef,
	downloadPdf,
	usedNewApi,
	renderConfig,
  theme,
  isCertValid,
  fallbackBackgroundImg,
}) => {
	const processedData = processGetData(rawDocument);

	const url = processedData?.["$template"]?.["url"];
	const { additionalData: { imageUrl } = {} } = processedData;
	const renderConfigID = processedData?.["additionalData"]?.["rendererConfigId"] || null;

	useEffect(() => {
		if (imageUrl) {
			getBadgeUrl(imageUrl);
		}
	}, [imageUrl]);

	return (
		<div style={{ textAlign: "center" }}>
      {certState === "revoked"
        ? <WarningBanner text="The credential has been revoked." />
        : isCertValid === false
          ? <WarningBanner text="The credential has been tampered with." />
          : creExpiredText !== ""
            ? <WarningBanner text={creExpiredText} labelStyle={{ fontSize: "1.3rem" }} />
            : null}
      {imageUrl && showBadge && <img src={imageUrl} style={{ width: "400px", height: "auto" }} alt=""/>}
			<div
				className="renderer-frame"
				style={{
					display: showBadge && "none",
					width: "100%",
					height: "100%",
					overflow: "hidden",
				}}>
				<Box style={{ display: "flex", flex: 1, flexDirection: "column", width: "100%", margin: "auto" }}>
					<CertView
            locale={locale}
            componentRef={componentRef}
            setIsDraft={setIsDraft}
            document={{ ...processedData, additionalDataMain: additionalDataMain || {} }}
            url={url}
            renderConfigID={renderConfigID}
            setPrintPageSize={setPrintPageSize}
            setCertBgImg={setCertBgImg}
            setFabricPageNames={setFabricPageNames}
            activePageName={activePageName}
            fabricCertiFullPageRef={fabricCertiFullPageRef}
            downloadPdf={downloadPdf}
            usedNewApi={usedNewApi}
            renderConfig={renderConfig}
            theme={theme}
            fallbackBackgroundImg={fallbackBackgroundImg}
					/>
				</Box>
			</div>
		</div>
	);
};

export default FrameView;
